module.exports = __webpack_public_path__ + "img/IMAGE000007.69b8b77b.jpeg";